<div class="container-fluid d-flex flex-fill flex-column gap-7">
    <div class="row">
        <div class="col-12 d-flex justify-content-between align-items-center px-0">
            <span class="heading-4 fw-semi-bold">Integrations</span>
        </div>
    </div>
    <div class="row gap-3">
        <div class="col-12 px-0">
            @if (mediaUploadService.isGroupUpload) {
                <div>Select which platforms to post your images to as a carousel. Each platform has a maximum image limit — if your group exceeds a platform's limit, only the first images up to that limit will be included.</div>
            } @else {
                <div>Select from the integrations below to choose where you would like to upload or post your media. Only the integrations that have been connected to ODDR and support video upload will be listed as supported.</div>
            }
        </div>
    </div>
    @if ((integrationsListLoading$ | async) === false && (integrationsListLoading$ | async) !== undefined) {
        @if (enabledIntegrationsList$ | async; as enabledItems) {
            @if (disabledIntegrationsList$ | async; as disabledItems) {
                @if (enabledItems.length > 0) {
                    <div class="row">
                        <div class="col-12 px-0">
                            <div class="d-flex align-items-center gap-3 mb-7">
                                <img alt="Supported" src="/assets/images/icons/check-circle-solid-success.svg" />
                                <div class="fs-6 fw-semi-bold">Supported</div>
                            </div>
                            <div class="d-flex flex-column flex-sm-row flex-wrap gap-7">
                                @for (integration of enabledItems; track $index) {
                                    <ng-container [ngTemplateOutlet]="integrationCard" [ngTemplateOutletContext]="{ integration }" />
                                }
                            </div>
                        </div>
                    </div>
                }

                @if (disabledItems.length > 0) {
                    <div class="row">
                        <div class="col-12 px-0">
                            <div class="d-flex align-items-center gap-3 mb-7">
                                <fa-icon [icon]="iconLibrary.CIRCLE_CROSS" class="text-danger" />
                                <div class="fs-6 fw-semi-bold">Unsupported</div>
                            </div>
                            <div class="d-flex flex-column flex-sm-row flex-wrap gap-7">
                                @for (integration of disabledItems; track $index) {
                                    <ng-container [ngTemplateOutlet]="integrationCard" [ngTemplateOutletContext]="{ integration }" />
                                }
                            </div>
                        </div>
                    </div>
                }

                @if (enabledItems.length === 0 && disabledItems.length === 0) {
                    <div class="row">
                        <div class="col-12 px-0">
                            <pp-alert [type]="alertType.Warning"
                                message="You do not have any connected integrations. If you want to automatically upload to any of your social media platforms,
                                cancel this upload, integrate with your social media platforms and attempt to upload again." />
                        </div>
                    </div>
                }
            }
        }
    }
    @else {
        <div class="mt-10">
            <pp-loading-otter [loading]="true" />
        </div>
    }
</div>
<div class="d-flex justify-content-between align-items-center mt-10">
    <ng-container *ngTemplateOutlet="uploadStatusIndicator" />
    <pp-button [disabled]="!((integrationsListLoading$ | async) === false && (integrationsListLoading$ | async) !== undefined)"
        [shape]="buttonShape.Square"
        [variant]="buttonVariant.Primary"
        (buttonClick)="submitAndGoToNextStep()">Next</pp-button>
</div>

<ng-template #uploadStatusIndicator>
    @if (uploadProgress > 0 && !uploadComplete()) {
        <div class="upload-progress-inline d-flex align-items-center gap-6">
            <span class="fs-6 fw-semi-bold text-nowrap">Uploading... {{ uploadProgress }}%</span>
            <div class="upload-progress-bar-track">
                <div class="upload-progress-bar-fill" [style.width.%]="uploadProgress"></div>
            </div>
        </div>
    } @else if (uploadComplete() && !processingComplete()) {
        <div class="d-flex align-items-center gap-3">
            <img alt="Processing" [src]="resolveImageIcon('time')" />
            <span class="fs-6 fw-semi-bold text-nowrap">Processing...</span>
        </div>
    } @else if (processingComplete()) {
        <div class="d-flex align-items-center gap-3">
            <img alt="Uploaded" src="/assets/images/icons/check-circle-solid-primary.svg" />
            <span class="fs-6 fw-semi-bold text-nowrap">Your media has been uploaded</span>
        </div>
    } @else {
        <div></div>
    }
</ng-template>

<ng-template #integrationCard let-integration="integration">
    <button type="button"
        class="card social-media-card"
        [class.selected]="isIntegrationSelected(integration.id)"
        [class.disabled]="isIntegrationDisabled(integration)"
        [disabled]="isIntegrationDisabled(integration)"
        (click)="updateSelectedItemList(integration)">
        <div class="card-body d-flex flex-column">
            <div class="integration-card-main d-flex flex-column">
                <img [src]="resolveIntegrationLogo(integration.imageFileName)" [alt]="integration.label" [height]="integration.imageHeight" [width]="integration.imageWidth" />
                <div class="d-flex flex-fill align-items-end">
                    <h4>{{ integration.label }}</h4>
                </div>
            </div>
            @if (getProviderMediaLimits(integration); as mediaLimits) {
                <div class="d-flex align-items-center gap-2 mt-5 text-start">
                    <span class="fs-8">Max file size: {{ mediaLimits.maxFileSize | formatFileSize }}</span>
                </div>
            }
            @if (isIntegrationDisabled(integration)) {
                <div class="d-flex align-items-start gap-2 mt-5 text-start">
                    <fa-icon [icon]="iconLibrary.CIRCLE_CROSS" class="text-danger" />
                    <span class="fs-8">
                        @if (integration.compatibilityErrors?.length) {
                            {{ integration.compatibilityErrors[0].message }}
                        } @else {
                            {{ getIntegrationDisabledReason(integration) }}
                        }
                    </span>
                </div>
            }
            @else if (getProviderImageWarning(integration); as warning) {
                <div class="d-flex align-items-start gap-2 mt-5 text-start">
                    <img alt="Warning" src="/assets/images/icons/info-oddr.svg" height="16px" width="16px" />
                    <span class="fs-8">{{ warning }}</span>
                </div>
            }
        </div>
    </button>
</ng-template>
